import React from 'react';

interface CartItemProps {
  name: string;
  price: string;
  size: 2 | 4;
}

const CartItem: React.FC<CartItemProps> = ({ name, price, size }) => {
  return (
    <div className="flex gap-2 justify-between py-[8px] border-b border-neutral-40">
      <p className={`p${size}-regular`}>{name}</p>
      <p className={`p${size}-regular`}>{price}</p>
    </div>
  );
};

export default CartItem;
